import { MemberDeleteOptions } from 'graphql/generated/graphqlTypes';

export const DELETE_GROUP_MEMBER_ACTION = {
  keep: 'keep',
  unassign: 'unassign',
  delete: 'delete'
} as const;

export type DeleteGroupMemberAction = (typeof DELETE_GROUP_MEMBER_ACTION)[keyof typeof DELETE_GROUP_MEMBER_ACTION];

export const MEMBER_ACTION_TO_DELETE_OPTIONS: Record<DeleteGroupMemberAction, MemberDeleteOptions> = {
  [DELETE_GROUP_MEMBER_ACTION.keep]: MemberDeleteOptions.NoVisitors,
  [DELETE_GROUP_MEMBER_ACTION.unassign]: MemberDeleteOptions.VisitorsWithoutOtherGroups,
  [DELETE_GROUP_MEMBER_ACTION.delete]: MemberDeleteOptions.AtlasManagedVisitors
};

export const OPTION_DESCRIPTION_MAX_WIDTH = 172;
